import React, {Component} from "react";

export class Services extends Component {
	render() {
		return (
			<div id="services" className="text-center">
				<div className="container">
					<div className="section-title">
						<h2>Who is myHrs for</h2>
						<p>
							People in the following professions seeking a license in California, New York, Texas or Florida
						</p>
					</div>
					<div className="row">
						{this.props.data
							? this.props.data.map((item, i) => (
								<div key={i} className={`col-xs-12 col-md-4 my-auto`}>
									<img src={`img/users/${item.image}.png`} className="img-fluid img-responsive mb-5" alt=""/>
									<h3>
										{item.title}
									</h3>
									<br/><br/>
								</div>
							))
							: "loading"}
					</div>
				</div>
			</div>
		);
	}
}

export default Services;



// WEBPACK FOOTER //
// ./src/components/services.jsx